<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <el-image v-if="swiperList && swiperList.length!=0"
              style="min-width: 1200px;height:463px;"
              @click="$Public.link(swiperList[0])"
              :src="swiperList[0].resourceUrl + '?imageMogr2/thumbnail/100000000@'"
              alt=""></el-image>
    <!-- 线下培训 -->
    <div class="offlineTraining_box">
      <div class="currency_box">
        <curTitle color="#000"
                  :data="{title:'外训与内训',content:'每年开设80余期线下课程，培训10000余名零售从业者'}"></curTitle>
      </div>
      <div class="currency_box">
        <offline></offline>
      </div>
    </div>
    <!-- 活动 -->
    <div class="retailTraining_box"
         v-loading="datalistloading">
      <div class="currency_boxs">
        <div class="flexStart"> <img :src="$imgUrl + 'RetailTraining/icon_img.png'"
               alt=""> <span class="title font40"
                style="margin-left:20px">线下活动安排</span>
          <span :class="courseData.openType == 1?'mainColor fontw font14':'font14'"
                style="margin:0 27px;cursor: pointer;"
                @click="openTypeClick(1)">当月线下系列课</span>
          <span :class="courseData.openType == 2?'mainColor fontw font14':'font14'"
                style="cursor: pointer;"
                @click="openTypeClick(2)">往期线下系列课</span>
        </div>
        <activity :list="dataList"></activity>
      </div>
    </div>
    <!-- 见证 -->
    <div class="witness_box"
         :style="{'backgroundImage':'url(' + $imgUrl+ 'home/bj/bj3.jpg)','backgroundSize':'100% 100%' ,'backgroundRepeat': 'no-repeat'}">
      <div class="currency_box">
        <curTitle color="#fff"
                  :data="{title:'客户见证 | 10000+客户共同选择',content:'深耕零售行业11年，服务10000+实体企业，助力企业持续增长'}"></curTitle>
      </div>
      <div class="currency_box">
        <witness :list="witnessList"></witness>
      </div>
    </div>
  </div>
</template>

<script>
import {
  resourceList, courseActivityList
} from '@/api/api.js'
import activity from '@/components/activity/activity.vue'
import offline from '@/components/activity/offline.vue'
import witness from '@/components/activity/witness.vue'
import curTitle from '@/components/home/cur_title.vue'
export default {
  components: {
    activity,
    offline,
    witness,
    curTitle
  },
  data () {
    return {
      datalistloading: false,
      dataList: [],
      swiperList: [],
      data: {
        showIndex: 3,
        pageNumber: 1,
        pageSize: 100
      },
      witnessList: [],
      courseData: {
        openType: 1,
        lectureId: '',
        pageNumber: 1,
        pageSize: 100
      }
    }
  },
  created () {
    this.getresourceList(3)
    this.getresourceList(10)
    this.getcourseActivityList()
  },
  methods: {
    async getresourceList (type) {  //获取首页资源
      this.data.showIndex = type
      const res = await resourceList(this.data)
      console.log(res)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      if (type == 3) {
        this.swiperList = res.data;
      } else {
        this.witnessList = this.split_array(res.data, 5)
      }
    },
    openTypeClick (type) {
      this.dataList = [];
      this.courseData.openType = type
      this.getcourseActivityList()
    },
    async getcourseActivityList () {
      this.datalistloading = true;
      const res = await courseActivityList(this.courseData)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      this.dataList = this.split_array(res.data.records, 3);
      this.datalistloading = false;
      console.log(res)
    },
    split_array (array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength));
      }
      // console.log(newArray)
      return newArray;
    },
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  min-height: 100vh;
  .fontw {
    font-weight: bold;
  }
  .offlineTraining_box {
    width: 100%;
    // height: 1488px;
    background-color: #fff;
  }
  .retailTraining_box {
    padding-top: 60px;
    background-color: #f5f5f5;
    width: 100%;
  }
  .witness_box {
    min-width: 1200px;
    padding: 50px 0;
    box-sizing: border-box;
    // height: 626px;
    background: rgba(0, 0, 0, 0.5);
    // font-family: '';
  }
}
</style>
